import { ICountry } from "@directives/_forms/smsInput/ICountry";
import { IAccountOptions } from "@services/class/AccountOption";
import * as angular from "angular";
import { ITimeZoneInfo } from "../model/ITimeZoneInfo";
import { SettingsModel } from "../model/preferences.model";

export class UserPreferencesService {

    static $inject = ["$http"];

    constructor(
        private readonly $http: angular.IHttpService) {
    }

    getUserOptions(): angular.IPromise<SettingsModel> {
        return this.$http
            .get("/api/useroptions/")
            .then((result: angular.IHttpPromiseCallbackArg<SettingsModel>) => {
                var userPreferences = result.data;

                userPreferences.Geofence.ShowLabelsWhenZoomedOut = userPreferences.Geofence.VisibleAt === "High";

                return userPreferences;
            });
    }

    getAccountOptions(): angular.IPromise<IAccountOptions> {
        return this.$http
            .get("/api/accountoptions/")
            .then((result: angular.IHttpPromiseCallbackArg<IAccountOptions>) => {
                return result.data;
            });
    }

    // This is for updating Vehicle Owner Credential Options
    saveUserOptions(userPreferences: SettingsModel): angular.IPromise<SettingsModel> {
        // Convert low / medium / high into something we can use as a bool for showing geofence labels when zoomed out
        userPreferences.Geofence.VisibleAt = userPreferences.Geofence.ShowLabelsWhenZoomedOut ? "High" : "Low";

        const promise = this.$http(
            {
                method: "POST",
                url: "/api/useroptions",
                data: userPreferences
            })
            .then((result: angular.IHttpPromiseCallbackArg<SettingsModel>) => {
                return result.data;
            });

        return promise;
    }

    // This is for updating Vehicle Owner Options (i.e. Journey Cost Value)
    saveAccountOptions(userPreferences: { key: string, value: string }[]): angular.IPromise<SettingsModel> {
        const promise = this.$http(
            {
                method: "POST",
                url: "/api/accountoptions",
                data: userPreferences
            })
            .then((result: angular.IHttpPromiseCallbackArg<SettingsModel>) => {
                return result.data;
            });

        return promise;
    }

    getTimezones(): angular.IPromise<ITimeZoneInfo[]> {
        return this.$http
            .get("/api/useroptions/timezones/")
            .then((result: angular.IHttpPromiseCallbackArg<ITimeZoneInfo[]>) => {
                return result.data;
            });
    }

    getCountryCodes(): angular.IPromise<ICountry[]> {
        return this.$http
            .get("/api/useroptions/countrycodes/")
            .then((result: angular.IHttpPromiseCallbackArg<ICountry[]>) => {
                return result.data;
            });
    }

    getTimezone(timeZoneName: string): angular.IPromise<ITimezoneSetting> {
        return this.$http
            .get(`/api/useroptions/timezone/${timeZoneName}`)
            .then((result: angular.IHttpResponse<ITimezoneSetting>) => {
                return result.data;
            });
    }
}
